export const CUSTOM_CAPTION = 'custom';
export const OBJECT_CAPTION = 'object';
export const ARRAY_CAPTION = 'array';
export const CLASS_CAPTION = 'class';
export const FUNCTION_CAPTION = 'func';
export const ELEMENT_CAPTION = 'element';
